"use client";

import { create } from "zustand";
import { persist } from "zustand/middleware";

interface BlogState {
  blogId: number | string;
  setBlogId: (id: number | string) => void;
  clearBlogId: () => void;
}

export const useBlogStore = create<BlogState>()(
  persist(
    (set) => ({
      blogId: 0,

      setBlogId: (id) => set({ blogId: id }),

      clearBlogId: () => set({ blogId: 0 }),
    }),
    {
      name: "blog-store",
    }
  )
);
